import { Button, Typography } from '@mui/material';
import { getTrans } from 'modules/i18n';
import { Iconify } from 'modules/minimal-ui-theme';

export const EditButton = ({ onEditItem }: { onEditItem: () => void }) => (
  <Button
    data-testid="edit-item-button"
    variant="outlined"
    startIcon={<Iconify icon="solar:pen-bold" width={18} />}
    onClick={onEditItem}
    sx={{
      color: 'dark.main',
      display: 'flex',
      height: '30px'
    }}
  >
    <Typography variant="body2" fontWeight="bold">
      {getTrans('general.edit')}
    </Typography>
  </Button>
);
